import { makeAutoObservable, runInAction } from 'mobx'
import { restaurantCenter, RESTAURANT_EVENT } from '..'
import ProductAPI from 'api/product.api'

type TMenuColor = {
  [productNo: string]: string;
}

class ProductExt {
  constructor () {
    makeAutoObservable(this)

    /** 监听 菜单排序或颜色 变更 */
    restaurantCenter.on(RESTAURANT_EVENT.MENU_EXT_REFRESH, () => {
      this.init()
    })
  }

  /** 记录菜单排序规则 */
  recordSort: IMenuSort = { categories: [], products: {} }

  /** 记录菜单颜色规则 */
  recordColor: TMenuColor = {}

  /** 记录菜单分类规则 */
  recordCategoriesColor: TMenuColor = {}

  /** 菜单排序规则 */
  sorts: IMenuSort = { categories: [], products: { } }

  /** 菜单颜色规则 */
  colors: TMenuColor = {}

  /** 菜单分类规则 */
  categoriesColor: TMenuColor = {}

  /** 初始化 */
  init () {
    return ProductAPI.getProductColorAndSort().then((res: any) => {
      if ((res?.content || []).length) {
        res.content.forEach((item: any) => {
          try {
            const data = JSON.parse(item.attrValue)
            if (item.attrType === 'productColor') {
              runInAction(() => {
                this.recordColor = data
                this.colors = data
              })
            }
            if (item.attrType === 'productSort') {
              runInAction(() => {
                this.recordSort = data
                this.sorts = data
              })
            }
            if (item.attrType === 'categoriesColor') {
              runInAction(() => {
                this.recordCategoriesColor = data
                this.categoriesColor = data
              })
            }
          } catch (error) {
            // do nothing
          }
        })
      }
    })
  }

  /** 保存规则 */
  save (colorData: any, sortData: any, categoriesColorData: any) {
    return ProductAPI.saveProductColorAndSort(colorData, sortData, categoriesColorData).then((res: any) => {
      this.recordColor = colorData
      this.recordSort = sortData
      return res
    })
  }

  /** 设置排序 */
  setSorts (data: IMenuSort) {
    this.sorts = data
  }

  /** 设置颜色 */
  setColors (data: TMenuColor) {
    this.colors = data
  }

  /** 设置分类颜色 */
  setCategoriesColor (data: TMenuColor) {
    this.categoriesColor = data
  }
}

export default new ProductExt()
